module.exports = __webpack_public_path__ + "static/media/signature.99bfdd98.svg";